module.exports = __webpack_public_path__ + "946610e56fc93dcffe662d1b0377b3a9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/empty-owlstagram/summer-owl.png
// module id = 508
// module chunks = 0